import type { GeoPoint } from '@/signalr/contracts';

export type HospitalInfo = {
  id: string;
  name: string;
  point: GeoPoint;
};

export function hospitalDisplayValue(hospital: HospitalInfo): string {
  return `${hospital.id} - ${hospital.name}`;
}

const hospital = (id: string, name: string, latitude: number, longitude: number): HospitalInfo => ({
  id,
  name,
  point: { latitude, longitude },
});

export const HOSPITALS: readonly HospitalInfo[] = [
  hospital('HPOPRA', 'POPRAD NEMOCNICA', 49.050861, 20.303861),
  hospital('HZILIN', 'ZILINA NEMOCNOCA', 49.215, 18.747083),
  hospital('HLIPTM', 'LIPTOVSKY MIKULAS', 49.083806, 19.596972),
  hospital('HSPINV', 'SPISSKA NOVA VES', 48.957, 20.565972),
  hospital('HBAANT', 'BRATISLAVA ANTOLSKA', 48.102917, 17.116806),
  hospital('HBAKRA', 'BRATISLAVA KRAMARE', 48.165944, 17.087361),
  hospital('HBANUS', 'BRATISLAVA NUSCH', 48.1706444, 17.0864667),
  hospital('HBBROS', 'BANSKA BYSTRICA FAKULTNA', 48.743806, 19.114528),
  hospital('HNITNE', 'NITRA NEMOCNICA', 48.299167, 18.083278),
  hospital('HKE', 'KOSICE ZAKLADNA', 48.724225, 21.235394),
  hospital('HPRESO', 'PRESOV FAKULTNA', 48.999333, 21.257944),
  hospital('HSTALU', 'STARA LUBOVNA NEMOCNICA', 49.296167, 20.688806),
  hospital('HKROMP', 'KROMPACHY NEMOCNICA', 48.902308, 20.870806),
  hospital('HKEZMAR', 'KEZMAROK NEMOCNICA', 49.132778, 20.420833),
  hospital('HLEVOC', 'LEVOCA NEMOCNICA', 49.025278, 20.594444),
  hospital('HBARUZ', 'BRATISLAVA RUZINOV HELIPORT ', 48.1549512, 17.1507104),
  hospital('HBANOV', 'BANOVCE NAD BEBRAVOU', 48.725722, 18.262639),
  hospital('HBARDE', 'BARDEJOV', 49.286389, 21.272222),
  hospital('HBOJNI', 'BOJNICE', 48.786306, 18.588472),
  hospital('HRUZST', 'RUZOMBEROK STRESNY HELIPORT', 49.074922, 19.310556),
  hospital('HKERAS', 'KOSICE RASTISLAVKA', 48.706413, 21.257),
  hospital('HBBSUS', 'BANSKA BYSTRICA SUSCH', 48.742003, 19.160717),
  hospital('heliport EPPO', 'HELIPORT POZNAN', 52.401389, 17.108333),
  hospital('HHUMEN', 'HUMENNE', 48.933472, 21.896394),
  hospital('HHNUST', 'HNUSTA', 48.574444, 19.955),
  hospital('HBANST', 'BANSKA STIAVNICA', 48.45465, 18.916861),
  hospital('HBREZN', 'BREZNO', 48.808127, 19.621685),
  hospital('HDETVA', 'DETVA', 48.545933, 19.415328),
  hospital('HDOLKU', 'DOLNY KUBIN', 49.212926, 19.301224),
  hospital('HDONOV', 'DONOVALY', 48.877229, 19.223043),
  hospital('HDUNST', 'DUNAJSKA STREDA', 47.997414, 17.610297),
  hospital('HGALAN', 'GALANTA', 48.195767, 17.722978),
  hospital('HGELNI', 'GELNICA', 48.858283, 20.944245),
  hospital('HHANDL', 'HANDLOVA', 48.727288, 18.768898),
  hospital('HILAVA', 'ILAVA', 48.993331, 18.231688),
  hospital('HKESAC', 'KOSICE SACA', 48.64314, 21.170764),
  hospital('HKOMAR', 'KOMARNO', 47.760467, 18.141828),
  hospital('HKRACH', 'KRALOVSKY CHLMEC', 48.419684, 21.985787),
  hospital('HKRUPI', 'KRUPINA', 48.359172, 19.06679),
  hospital('HLEVIC', 'LEVICE', 48.222703, 18.616542),
  hospital('HLUCEN', 'LUCENEC', 48.326982, 19.659707),
  hospital('HMALAC', 'MALACKY', 48.439352, 17.031533),
  hospital('HMARTI', 'MARTIN', 49.059277, 18.917847),
  hospital('HMICH1', 'MICHALOVCE', 48.748703, 21.918024),
  hospital('HMYJAV', 'MYJAVA', 48.764256, 17.559788),
  hospital('HNITNO', 'NITRA ZELEZNICNA', 48.296513, 18.078844),
  hospital('HNOBAN', 'NOVA BANA', 48.417216, 18.644146),
  hospital('HNOMES', 'NOVE MESTO NAD VAHOM', 48.7579725, 17.8180581),
  hospital('HNOZAM', 'NOVE ZAMKY', 47.988449, 18.150073),
  hospital('HPARTIZ', 'PARTIZANSKE', 48.6345, 18.4055),
  hospital('HPOVBY', 'POVAZSKA BYSTRICA', 49.105341, 18.458115),
  hospital('HREVUC', 'REVUCA', 48.692664, 20.120439),
  hospital('HRIMSO', 'RIMAVSKA SOBOTA', 48.376268, 20.019869),
  hospital('HROZNA', 'ROZNAVA', 48.666131, 20.534405),
  hospital('HSKALI', 'SKALICA', 48.845279, 17.234534),
  hospital('HSNINA', 'SNINA', 48.9854517, 22.1497397),
  hospital('HSVIDN', 'SVIDNIK', 49.310534, 21.56089),
  hospital('HSALA', 'SALA', 48.151825, 17.872287),
  hospital('HSAHY', 'SAHY', 48.078821, 18.948468),
  hospital('HSTURO', 'STUROVO', 47.785984, 18.703428),
  hospital('HTOPOL', 'TOPOLCANY', 48.551941, 18.166616),
  hospital('HTREBI', 'TREBISOV', 48.618232, 21.714081),
  hospital('HTRENC', 'TRENCIN', 48.883067, 18.029294),
  hospital('HTRNAV', 'TRNAVA', 48.368924, 17.593101),
  hospital('HVELKR', 'VELKY KRTIS', 48.212058, 19.353),
  hospital('HVRANO', 'VRANOV NAD TOPLOU', 48.885762, 21.693859),
  hospital('HZLAMO', 'ZLATE MORAVCE', 48.38589, 18.394741),
  hospital('HZIARN', 'ZIAR NAD HRONOM', 48.599869, 18.840424),
  hospital('HDUSL1', 'DUSLO SALA 1', 48.187594, 17.92772),
  hospital('HDUSL2', 'DUSLO SALA 2', 48.172771, 17.948062),
  hospital('HHNUST', 'HNUSTA', 48.574381, 19.955325),
  hospital('HKOVAC', 'KOVACOVA', 48.609656, 19.104072),
  hospital('HPEBA1', 'PEZINSKA BABA 1', 48.340693, 17.221237),
  hospital('HPEBA2', 'PEZINSKA BAB 2', 48.349967, 17.201265),
  hospital('HSENJA', 'SENECKE JAZERA', 48.215265, 17.415402),
  hospital('HJASBO', 'Jaslovske Bohunice', 48.499358, 17.684988),
  hospital('HMOCH1', 'MOCHOVCE parkovisko 1', 48.255385, 18.456445),
  hospital('HMOCH2', 'MOCHOVCE parkovisko 2', 48.255357, 18.456531),
  hospital('HMOCH3', 'MOCHOVCE ELEKTRAREN ', 48.266471, 18.453012),
  hospital('HMOCH4', 'MOCHOVCE ELEKTRAREN ', 48.270098, 18.452347),
  hospital('HSMOKO', 'HZS SMOKOVEC', 49.13702, 20.222419),
  hospital('HJASN1', 'Jasna DOM HZS', 48.965693, 19.584981),
  hospital('HJASN2', 'Jasna Priehyba', 48.963155, 19.59016),
  hospital('HBRNCA', 'Brncalova chata', 49.210493, 20.221544),
  hospital('HCADCA', 'CADCA', 49.438473, 18.770364),
  hospital('HMARHO', 'MARTINSKE HOLE', 49.096806, 18.842371),
  hospital('HOSGRU', 'OSTRY GRUN VRATNA', 49.21969, 19.053043),
  hospital('HVRATNA', 'VRATNA ', 49.233342, 19.053312),
  hospital('HTORNA', 'TORNALA', 48.42633, 20.32018),
  hospital('HVYHAG', 'VYSNE HAGY', 49.11487, 20.12893),
  hospital('HNAMES', 'NAMESTOVO', 49.41189, 19.4855),
  hospital('HPIEST', 'PIESTANY', 48.59872, 17.84467),
  hospital('HBAMED', 'BRATISLAVA MEDISSIMO', 48.10128, 17.10857),
  hospital('VL', 'VELKA LOMNICA', 49.106167, 20.343867),
  hospital('LZHRAB', 'Hrabusice', 48.969141, 20.386862),
  hospital('TOPR', 'BASE', 49.30565, 19.95593),
  hospital('HELIPORT', 'LIPTOV', 49.06793, 19.64728),
  hospital('Teryho chata', 'chata', 49.19026, 20.19979),
  hospital('Rysy chata', 'chata', 49.17407, 20.08609),
  hospital('HOREPO', 'orechova poton', 48.05654, 17.57151),
  hospital('FAWP NUSCH', 'Finaly approach waypoint', 48.1586417, 17.1038194),
  hospital('FAWP ZA', 'Finaly approach waypoint', 49.2186111, 18.81),
  hospital('FAWP SUSCH', 'Finaly approach waypoint', 48.705, 19.2116667),
  hospital('FAWP BB', 'Finaly approach waypoint', 48.70775, 19.126916),
  hospital('FAWP KE', 'Finaly approach waypoint', 48.7613389, 21.2369194),
  hospital('FAWP RUZINOV', 'Finaly approach waypoint', 48.1425194, 17.1529528),
  hospital('HBARUP', 'Bratislava  Ruzinov PIS', 48.15625, 17.154),
  hospital('HBABOR', 'BORY', 48.2079666666667, 17.0314),
  hospital('FAWP BORY 1km', 'fawp bory', 48.201691, 17.0410717),
  hospital('FAWP BORY 1nm', 'fawp bory 1nm', 48.1962608, 17.04925),
];
